class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  connectedCallback() {
    this.updateOptions();
    this.updateMasterId();
    this.updateVariantStatuses();
    this.updateMedia();
    this.updateDimensions();
  }

  onVariantChange(e) {
    const { isCombinedProduct, targetUrl } = this.combinedListingCheck(e);

    this.toggleAddButton(true, '', false);
    if (typeof this.hideUnavailableMessage === 'function') {
      this.hideUnavailableMessage();
    }

    if (isCombinedProduct) {
      this.fetchProductSection(targetUrl);
      return;  // Stop execution if false
    }

    this.updateOptions();
    this.updateMasterId();
    this.updatePickupAvailability();
    this.updateInventoryStatus();
    this.removeErrorMessage();
    const selectionAdjusted = this.updateVariantStatuses();
    if (selectionAdjusted) return;

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateDimensions();
      this.updateURL();
      this.updateVariantInput();
      this.dispatchVariantChange();
      this.updateSveaWidget();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  combinedListingCheck(e) {
    const currentUrl = window.location.pathname;
    const targetUrl = e.target.dataset.productUrl;
    let isCombinedProduct = false;

    if (targetUrl != undefined && currentUrl != targetUrl) {
      isCombinedProduct = true;
    }

    return { isCombinedProduct, targetUrl };
  }

  async fetchProductSection(newProductUrl) {
    const productElement = this.closest('.main-product');
    const productSectionId = this.dataset.section;
    let params = `section_id=${productSectionId}&`;

    const selectedOptionValues = Array.from(this.querySelectorAll('fieldset input:checked')).map((element) => element.dataset.optionValueId).join(',');
      params += `option_values=${selectedOptionValues}`;

    fetch(`${newProductUrl}?${params}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        productElement.innerHTML = html.querySelector('.main-product').innerHTML;
        window.history.replaceState({ }, '', `${newProductUrl}`);
      });
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;

    const mediaGridySlider = document.getElementById(`slider-${this.dataset.section}`);
    const thumbnailsGridySlider = document.getElementById(`thumbnail-slider-${this.dataset.section}`);
    const zoomGridySlider = document.getElementById(`zoom-slider-${this.dataset.section}`);
    const debugMedia = /(?:[?&])debugMedia=1(?:&|$)/.test(window.location.search);

    const visibility = this.updateMediaVisibility() || {};

    const featuredMediaId = this.currentVariant.featured_media?.id;
    const hasVisibleFeatured = !!(featuredMediaId && visibility.visibleIds?.has(String(featuredMediaId)));
    const targetMediaId = hasVisibleFeatured
      ? featuredMediaId
      : visibility.firstVisibleId;

    if (debugMedia) {
      console.groupCollapsed('[media-debug] updateMedia', {
        variantId: this.currentVariant.id,
        sku: this.currentVariant.sku,
        featuredMediaId,
        targetMediaId,
        firstVisibleId: visibility.firstVisibleId,
        visibleIds: Array.from(visibility.visibleIds || [])
      });
    }

    if (targetMediaId) {
      const targetItem = document.getElementById(`item-${targetMediaId}`);
      if (targetItem) {
        targetItem.hidden = false;
        targetItem.style.position = '';
        targetItem.style.top = '';
        targetItem.style.left = '';
        targetItem.style.width = '';
        targetItem.style.height = '';
        targetItem.style.margin = '';
        targetItem.style.pointerEvents = '';
        targetItem.style.transform = '';
        targetItem.style.transition = '';
        targetItem.style.opacity = '1';
        const img = targetItem.querySelector('img');
        if (img) {
          img.loading = 'eager';
          img.fetchPriority = 'high';
          if (!img.currentSrc && img.getAttribute('src')) {
            img.src = img.getAttribute('src');
          } else if (img.complete === false && img.getAttribute('src')) {
            img.src = img.getAttribute('src');
          }
          img.decode?.().catch(() => {});
        }
        if (debugMedia) {
          const figure = targetItem.querySelector('figure');
          const itemStyles = window.getComputedStyle(targetItem);
          const figStyles = figure ? window.getComputedStyle(figure) : null;
          const imgStyles = img ? window.getComputedStyle(img) : null;
          console.log('[media-debug] target item state', {
            id: targetItem.id,
            hidden: targetItem.hidden,
            display: itemStyles.display,
            visibility: itemStyles.visibility,
            opacity: itemStyles.opacity,
            width: itemStyles.width,
            height: itemStyles.height,
            classes: targetItem.className
          });
          if (figure) {
            console.log('[media-debug] target figure state', {
              display: figStyles.display,
              visibility: figStyles.visibility,
              opacity: figStyles.opacity,
              width: figStyles.width,
              height: figStyles.height,
              classes: figure.className
            });
          }
          if (img) {
            console.log('[media-debug] target img state', {
              currentSrc: img.currentSrc,
              src: img.getAttribute('src'),
              naturalWidth: img.naturalWidth,
              naturalHeight: img.naturalHeight,
              complete: img.complete,
              display: imgStyles.display,
              visibility: imgStyles.visibility,
              opacity: imgStyles.opacity,
              width: imgStyles.width,
              height: imgStyles.height
            });
          } else {
            console.warn('[media-debug] target img missing', { id: targetItem.id });
          }
        }
      }
    }

    if (mediaGridySlider) {
      const track = mediaGridySlider.querySelector('.gridy-track');
      if (debugMedia && track) {
        console.log('[media-debug] main track before', {
          scrollLeft: track.scrollLeft,
          scrollWidth: track.scrollWidth,
          clientWidth: track.clientWidth
        });
      }
      if (track) {
        const prevDisplay = track.style.display;
        track.style.display = 'none';
        track.offsetHeight;
        track.style.display = prevDisplay;
      }
      if (targetMediaId) {
        mediaGridySlider.refreshSlides?.();
        mediaGridySlider.scrollToSlideByID(`item-${targetMediaId}`);
        if (track) {
          const targetItem = document.getElementById(`item-${targetMediaId}`);
          if (targetItem) {
            const baseOffset = track.firstElementChild ? track.firstElementChild.offsetLeft : 0;
            const nextLeft = Math.max(0, targetItem.offsetLeft - baseOffset);
            track.scrollTo({ left: nextLeft, top: 0, behavior: "instant" });
            if (debugMedia) {
              console.log('[media-debug] main track scroll instant', {
                targetId: `item-${targetMediaId}`,
                nextLeft
              });
            }
          }
        }
        setTimeout(() => {
          mediaGridySlider.refreshSlides?.();
          mediaGridySlider.scrollToSlideByID(`item-${targetMediaId}`);
          if (track) {
            const targetItem = document.getElementById(`item-${targetMediaId}`);
            if (targetItem) {
              const baseOffset = track.firstElementChild ? track.firstElementChild.offsetLeft : 0;
              const nextLeft = Math.max(0, targetItem.offsetLeft - baseOffset);
              track.scrollTo({ left: nextLeft, top: 0, behavior: "instant" });
              if (debugMedia) {
                console.log('[media-debug] main track scroll instant (delayed)', {
                  targetId: `item-${targetMediaId}`,
                  nextLeft
                });
              }
            }
          }
        }, 260);
      }
      if (debugMedia && track) {
        const visibleItems = Array.from(track.querySelectorAll('[data-media-item]')).filter((item) => !item.hidden);
        console.log('[media-debug] main track visible items', visibleItems.map((item) => item.id));
      }
    }

    if (thumbnailsGridySlider) {
      if (targetMediaId) {
        thumbnailsGridySlider.scrollToSlideByID(`thumbnail-item-${targetMediaId}`);
      }
    }

    this.updateThumbnailActive(targetMediaId);

    const isDesktop = window.matchMedia('(min-width: 1024px)').matches;
    const isGrid = mediaGridySlider && mediaGridySlider.dataset.desktopEnabled === 'false' ? true : false;
    if (isDesktop && isGrid && targetMediaId) {
      document.getElementById(`item-${targetMediaId}`)?.scrollIntoView();
    }

    if (debugMedia) {
      console.groupEnd();
    }
  }

  updateMediaVisibility() {
    if (!this.currentVariant) return;

    const variantId = String(this.currentVariant.id);
    const mediaGridySlider = document.getElementById(`slider-${this.dataset.section}`);
    const thumbnailsGridySlider = document.getElementById(`thumbnail-slider-${this.dataset.section}`);
    const zoomGridySlider = document.getElementById(`zoom-slider-${this.dataset.section}`);

    if (!mediaGridySlider) return;
    const mediaTrack = mediaGridySlider.querySelector('.gridy-track');
    if (!mediaTrack) return;

    const mediaItems = Array.from(mediaGridySlider.querySelectorAll('[data-media-item]'));
    const getIds = (item, key) =>
      (item.dataset[key] || '').split(',').map((id) => id.trim()).filter(Boolean);
    const getFilename = (item, key) => {
      const raw = (item.dataset[key] || '').toLowerCase();
      if (raw) return raw;

      const img = item.querySelector && item.querySelector('img');
      const src = (img?.currentSrc || img?.getAttribute?.('src') || '').toLowerCase();
      if (!src) return '';
      const base = src.split('?')[0];
      const parts = base.split('/');
      return parts[parts.length - 1] || '';
    };
    const allSkus = (this.variantData || this.getVariantData())
      .map((variant) => String(variant.sku || '').trim())
      .filter(Boolean);
    const skuSet = new Set(allSkus.map((sku) => sku.toLowerCase()));

    const currentSku = String(this.currentVariant.sku || '').trim().toLowerCase();
    const hasAnyVariantMedia = mediaItems.some((item) => getIds(item, 'mediaVariantIds').length > 0);
    const showAll = !hasAnyVariantMedia && skuSet.size === 0;
    const debugMedia = /(?:[?&])debugMedia=1(?:&|$)/.test(window.location.search);
    if (debugMedia) {
      console.groupCollapsed('[media-debug] variant', {
        id: this.currentVariant.id,
        sku: currentSku,
        options: this.currentVariant.options
      });
      console.log('variants available', (this.variantData || this.getVariantData()).map((v) => ({
        id: v.id,
        sku: v.sku,
        options: v.options
      })));
      console.log('media items', mediaItems.map((item) => ({
        id: item.id,
        filename: getFilename(item, 'mediaFilename'),
        variantIds: getIds(item, 'mediaVariantIds')
      })));
      console.groupEnd();
    }

    const skuList = Array.from(skuSet).sort((a, b) => b.length - a.length);
    const getMatchedSkus = (filename) => {
      if (!filename || skuList.length === 0) return [];
      const matches = [];
      for (const sku of skuList) {
        if (!sku) continue;
        const re = new RegExp(`(^|[^a-z0-9])${sku}([^a-z0-9]|$)`, 'i');
        if (re.test(filename)) matches.push(sku);
      }
      return matches;
    };

    const shouldShowMedia = (datasetKey, filenameKey) => (item) => {
      const filename = getFilename(item, filenameKey);
      const matchedSkus = getMatchedSkus(filename);
      const ids = getIds(item, datasetKey);

      if (matchedSkus.length) {
        const hasCurrentSku = currentSku && matchedSkus.includes(currentSku);
        if (debugMedia) {
          console.log('[media-debug] sku-match(es)', {
            mediaId: item.id,
            filename,
            matchedSkus,
            currentSku
          });
        }
        return hasCurrentSku;
      }
      if (ids.length) {
        if (debugMedia) {
          console.log('[media-debug] variant-ids match', {
            mediaId: item.id,
            filename,
            ids,
            variantId
          });
        }
        return ids.includes(variantId);
      }
      if (showAll) return true;
      if (!filename) return false;
      return true;
    };

    const nextVisibility = new Map(
      mediaItems.map((item) => [item, shouldShowMedia('mediaVariantIds', 'mediaFilename')(item)])
    );
    const featuredId = this.currentVariant.featured_media?.id ? `item-${this.currentVariant.featured_media.id}` : null;
    if (featuredId && !nextVisibility.get(document.getElementById(featuredId))) {
      const featuredItem = mediaItems.find((item) => item.id === featuredId);
      if (featuredItem) nextVisibility.set(featuredItem, true);
    }

    let visibleItemsNext = mediaItems.filter((item) => nextVisibility.get(item));
    if (visibleItemsNext.length === 0) {
      let fallbackItems = [];
      if (currentSku) {
        fallbackItems = mediaItems.filter((item) => {
          const filename = getFilename(item, 'mediaFilename');
          return filename && filename.includes(currentSku);
        });
      }
      if (fallbackItems.length === 0 && variantId) {
        fallbackItems = mediaItems.filter((item) => getIds(item, 'mediaVariantIds').includes(variantId));
      }
      if (fallbackItems.length === 0 && mediaItems.length) {
        fallbackItems = [mediaItems[0]];
      }
      fallbackItems.forEach((item) => nextVisibility.set(item, true));
      visibleItemsNext = mediaItems.filter((item) => nextVisibility.get(item));
      if (debugMedia) {
        console.warn('[media-debug] fallback used', {
          currentSku,
          variantId,
          fallbackIds: fallbackItems.map((item) => item.id)
        });
      }
    }
    const visibleIds = new Set(
      visibleItemsNext.map((item) => item.id?.replace('item-', '')).filter(Boolean)
    );
    const firstVisibleId = visibleItemsNext[0]?.id?.replace('item-', '');

    const firstRects = new Map();
    mediaItems.forEach((item) => {
      if (!item.hidden && nextVisibility.get(item)) {
        firstRects.set(item, item.getBoundingClientRect());
      }
    });

    const isSliderLayout = mediaGridySlider && (mediaGridySlider.dataset.desktopEnabled === 'true' || mediaGridySlider.dataset.mobileEnabled === 'true');
    const fadeDuration = 220;
    if (!isSliderLayout) {
      mediaItems.forEach((item) => {
        const willShow = nextVisibility.get(item);
        if (willShow) {
          item.hidden = false;
          item.style.position = '';
          item.style.top = '';
          item.style.left = '';
          item.style.width = '';
          item.style.height = '';
          item.style.margin = '';
          item.style.pointerEvents = '';
          item.style.transform = '';
          item.style.transition = '';
          item.style.opacity = '1';
        }
      });

      mediaItems.forEach((item) => {
        const willShow = nextVisibility.get(item);
        if (!willShow && !item.hidden) {
          const rect = item.getBoundingClientRect();
          const trackRect = mediaTrack.getBoundingClientRect();
          item.style.position = 'absolute';
          item.style.top = `${rect.top - trackRect.top + mediaTrack.scrollTop}px`;
          item.style.left = `${rect.left - trackRect.left + mediaTrack.scrollLeft}px`;
          item.style.width = `${rect.width}px`;
          item.style.height = `${rect.height}px`;
          item.style.margin = '0';
          item.style.pointerEvents = 'none';
          item.style.opacity = '1';

          item.animate([{ opacity: 1 }, { opacity: 0 }], {
            duration: fadeDuration,
            easing: 'ease',
            fill: 'forwards'
          }).onfinish = () => {
            item.hidden = true;
            item.style.position = '';
            item.style.top = '';
            item.style.left = '';
            item.style.width = '';
            item.style.height = '';
            item.style.margin = '';
            item.style.pointerEvents = '';
            item.style.opacity = '';
          };
        }
      });

      requestAnimationFrame(() => {
        mediaItems.forEach((item) => {
          const willShow = nextVisibility.get(item);
          if (willShow && item.style.opacity === '0') {
            item.style.transition = `opacity ${fadeDuration}ms ease`;
            item.style.opacity = '1';
          }
        });

        mediaItems.forEach((item) => {
          if (!nextVisibility.get(item)) return;
          const first = firstRects.get(item);
          if (!first) return;
          const last = item.getBoundingClientRect();
          const dx = first.left - last.left;
          const dy = first.top - last.top;
          if (dx || dy) {
            item.style.transform = `translate(${dx}px, ${dy}px)`;
            item.style.transition = `transform ${fadeDuration}ms ease`;
            requestAnimationFrame(() => {
              item.style.transform = '';
            });
            item.addEventListener('transitionend', () => {
              item.style.transition = '';
            }, { once: true });
          }
        });
      });
    } else {
      mediaItems.forEach((item) => {
        const willShow = nextVisibility.get(item);
        item.hidden = !willShow;
        item.style.position = '';
        item.style.top = '';
        item.style.left = '';
        item.style.width = '';
        item.style.height = '';
        item.style.margin = '';
        item.style.pointerEvents = '';
        item.style.transform = '';
        item.style.transition = '';
        item.style.opacity = willShow ? '1' : '';
      });
    }

    if (thumbnailsGridySlider) {
      const thumbItems = Array.from(thumbnailsGridySlider.querySelectorAll('[data-thumbnail-btn]'));
      thumbItems.forEach((item) => {
        item.hidden = !shouldShowMedia('thumbnailVariantIds', 'thumbnailFilename')(item);
      });
      thumbnailsGridySlider.refreshSlides?.();
    }

    if (zoomGridySlider) {
      if (debugMedia) {
        const zoomBefore = Array.from(zoomGridySlider.querySelectorAll('[data-zoom-item]')).filter((item) => !item.hidden);
        console.log('[media-debug] zoom visible items (before)', zoomBefore.map((item) => item.id));
      }
      const zoomItems = Array.from(zoomGridySlider.querySelectorAll('[data-zoom-item]'));
      zoomItems.forEach((item) => {
        item.hidden = !shouldShowMedia('zoomVariantIds', 'zoomFilename')(item);
      });
      zoomGridySlider.refreshSlides?.();

      const visibleZoomItems = zoomItems.filter((item) => !item.hidden);
      if (debugMedia) {
        console.log('[media-debug] zoom visible items (after)', visibleZoomItems.map((item) => item.id));
      }
      visibleZoomItems.forEach((item, index) => {
        const label = item.querySelector('.item-number span');
        if (label) label.textContent = `${index + 1} / ${visibleZoomItems.length}`;
      });
    }

    mediaGridySlider.refreshSlides?.();

    return {
      visibleIds,
      firstVisibleId
    };
  }

  updateThumbnailActive(targetMediaId) {
    const thumbnailsGridySlider = document.getElementById(`thumbnail-slider-${this.dataset.section}`);
    if (!thumbnailsGridySlider) return;

    const thumbItems = Array.from(thumbnailsGridySlider.querySelectorAll('[data-thumbnail-btn]'));
    thumbItems.forEach((item) => item.classList.remove('active'));

    let activeThumb = null;
    if (targetMediaId) {
      activeThumb = document.getElementById(`thumbnail-item-${targetMediaId}`);
      if (activeThumb && activeThumb.hidden) activeThumb = null;
    }

    if (!activeThumb) {
      activeThumb = thumbItems.find((item) => !item.hidden) || null;
    }

    if (activeThumb) activeThumb.classList.add('active');
  }

  updateDimensions() {
    if (!this.currentVariant) return;
    const scope = this.closest('section') || document;
    const details = scope.querySelector('[data-mitat]');
    if (!details) return;

    const content = details.querySelector('[data-mitat-content]');
    const dataScript = details.querySelector('[data-mitat-variants]');
    if (!content || !dataScript) return;

    let data = {};
    try {
      data = JSON.parse(dataScript.textContent);
    } catch (e) {
      return;
    }

    const entry = data[this.currentVariant.id];
    if (!entry || !entry.html) {
      content.innerHTML = '';
      details.hidden = true;
      return;
    }

    content.innerHTML = entry.html;
    details.hidden = false;
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}, #product-form-${this.dataset.section}-product-buy-bar`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  dispatchVariantChange() {
    if (!this.currentVariant) return;
    document.dispatchEvent(new CustomEvent('woolman:variant:change', {
      detail: {
        variant: this.currentVariant,
        sectionId: this.dataset.section || null
      }
    }));
  }

  updateSveaWidget() {
    if (!this.currentVariant) return;
    const sectionId = this.dataset.section;
    const shopifySection = sectionId ? document.getElementById(`shopify-section-${sectionId}`) : null;
    const scope =
      shopifySection
      || this.closest('.main-product')
      || this.closest('.shopify-section')
      || this.closest('section')
      || document;

    const widgets = Array.from(scope.querySelectorAll('[data-svea-widget]'));
    if (!widgets.length) return;

    const getQuantityValue = () => {
      const formId = `product-form-${this.dataset.section}`;
      const form = document.getElementById(formId);
      const candidates = [
        form?.querySelector('input[name="quantity"]'),
        scope.querySelector(`input[name="quantity"][form="${formId}"]`),
        scope.querySelector(`#${formId} input[name="quantity"]`)
      ].filter(Boolean);
      const input = candidates[0] || null;
      if (!input) return 1;

      const fromValue = parseInt(String(input.value || '').trim(), 10);
      if (Number.isFinite(fromValue) && fromValue > 0) return fromValue;

      const fromMinMultiple = parseInt(String(input.dataset?.minMultiple || '').trim(), 10);
      if (Number.isFinite(fromMinMultiple) && fromMinMultiple > 0) return fromMinMultiple;

      const fromMinAttr = parseInt(String(input.getAttribute('min') || '').trim(), 10);
      if (Number.isFinite(fromMinAttr) && fromMinAttr > 0) return fromMinAttr;

      return 1;
    };

    const basePrice = Number(this.currentVariant.price || 0) / 100;
    const quantity = getQuantityValue();
    const price = basePrice * quantity;
    if (!Number.isFinite(price) || price <= 0) return;

    const normalizeDatasetValue = (value) => {
      if (value === undefined || value === null) return null;
      const text = String(value).trim();
      return text.length ? text : null;
    };

    widgets.forEach((widgetRoot) => {
      const currentScript = widgetRoot.querySelector('.svea-pp-widget-part-payment');
      const dataset = widgetRoot.dataset || {};
      const config = {
        src: normalizeDatasetValue(dataset.sveaSrc) || currentScript?.src || null,
        sellerid: normalizeDatasetValue(dataset.sveaSellerid) || currentScript?.getAttribute('data-sellerid') || null,
        host: normalizeDatasetValue(dataset.sveaHost) || currentScript?.getAttribute('data-maksuturva-host') || null,
        thresholdPrices: normalizeDatasetValue(dataset.sveaThresholdPrices) || currentScript?.getAttribute('data-threshold-prices') || null,
        activeColor: normalizeDatasetValue(dataset.sveaActiveColor) || currentScript?.getAttribute('data-active-color') || null,
        textColor: normalizeDatasetValue(dataset.sveaTextColor) || currentScript?.getAttribute('data-text-color') || null,
        highlightColor: normalizeDatasetValue(dataset.sveaHighlightColor) || currentScript?.getAttribute('data-highlight-color') || null,
        borderColor: normalizeDatasetValue(dataset.sveaBorderColor) || currentScript?.getAttribute('data-border-color') || null,
        borderRadius: normalizeDatasetValue(dataset.sveaBorderRadius) || currentScript?.getAttribute('data-border-radius') || null,
        locale: normalizeDatasetValue(dataset.sveaLocale) || currentScript?.getAttribute('data-locale') || null,
        layout: normalizeDatasetValue(dataset.sveaLayout) || currentScript?.getAttribute('data-layout') || null
      };

      if (!config.sellerid) return;

      const newScript = document.createElement('script');
      newScript.className = 'svea-pp-widget-part-payment';
      newScript.setAttribute('data-price', String(price));
      if (config.sellerid) newScript.setAttribute('data-sellerid', config.sellerid);
      if (config.host) newScript.setAttribute('data-maksuturva-host', config.host);
      if (config.thresholdPrices) newScript.setAttribute('data-threshold-prices', config.thresholdPrices);
      if (config.activeColor) newScript.setAttribute('data-active-color', config.activeColor);
      if (config.textColor) newScript.setAttribute('data-text-color', config.textColor);
      if (config.highlightColor) newScript.setAttribute('data-highlight-color', config.highlightColor);
      if (config.borderColor) newScript.setAttribute('data-border-color', config.borderColor);
      if (config.borderRadius) newScript.setAttribute('data-border-radius', config.borderRadius);
      if (config.locale) newScript.setAttribute('data-locale', config.locale);
      if (config.layout) newScript.setAttribute('data-layout', config.layout);
      if (config.src) newScript.src = config.src;

      widgetRoot.innerHTML = '';
      widgetRoot.appendChild(newScript);
      newScript.onload = () => {
        try {
          document.dispatchEvent(new CustomEvent('svea-partpayment-calculator'));
        } catch (e) {}
      };
    });

    try {
      document.dispatchEvent(new CustomEvent('svea-partpayment-calculator'));
    } catch (e) {}
  }

  updateVariantStatuses() {
    if (!this.variantData) return false;
    const option1Value = (this.options && this.options.length ? this.options[0] : null)
      || this.querySelector('input:checked, option:checked')?.value;
    if (!option1Value) return false;

    const selectedOptionOneVariants = this.variantData.filter((variant) => option1Value === variant.option1);
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    for (let index = 1; index < inputWrappers.length; index += 1) {
      const option = inputWrappers[index];
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      if (!optionInputs.length) continue;

      const previousSelected = inputWrappers[index - 1].querySelector('input:checked, option:checked');
      const previousOptionSelected = previousSelected?.value;
      if (!previousOptionSelected) continue;

      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${ index }`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${ index + 1 }`]);

      this.setInputAvailability(optionInputs, availableOptionInputsValue);

      const currentSelected = option.querySelector('input:checked, option:checked');
      const currentValue = currentSelected?.value;
      if (currentSelected && currentValue && !availableOptionInputsValue.includes(currentValue)) {
        const fallback = this.pickFallbackOption(optionInputs, availableOptionInputsValue);
        if (fallback) {
          this.applyFallbackSelection(fallback);
          return true;
        }
      }
    }
    return false;
  }

  pickFallbackOption(optionInputs, availableValues) {
    if (!availableValues || availableValues.length === 0) return null;
    const uniqueValues = Array.from(new Set(availableValues));
    const preferredValue = uniqueValues.find((value) => {
      const text = String(value || '');
      return /(^|\s)ilman(\s|$)/i.test(text)
        || /\bnone\b/i.test(text)
        || /\bwithout\b/i.test(text)
        || /\bno\b/i.test(text)
        || /(^|\s)ei(\s|$)/i.test(text);
    });
    const targetValue = preferredValue || uniqueValues[0];
    return optionInputs.find((input) => input.getAttribute('value') === targetValue);
  }

  applyFallbackSelection(input) {
    if (!input) return;
    if (input.tagName === 'OPTION') {
      input.selected = true;
      const select = input.closest('select');
      if (select) {
        select.value = input.value;
      }
    } else {
      input.checked = true;
    }
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  getUnavailableMessageText() {
    if (this.dataset.unavailableMessage) return this.dataset.unavailableMessage;
    if (window.variantStrings && window.variantStrings.unavailableVariant) return window.variantStrings.unavailableVariant;
    if (window.variantStrings && window.variantStrings.unavailable) return window.variantStrings.unavailable;
    return 'Tätä varianttia ei ole saatavilla';
  }

  showUnavailableMessage() {
    const message = this.querySelector('[data-variant-unavailable-message]');
    if (!message) return;
    message.textContent = this.getUnavailableMessageText();
    message.hidden = false;
    message.classList.add('is-visible');
    if (this.unavailableMessageTimer) {
      window.clearTimeout(this.unavailableMessageTimer);
    }
    this.unavailableMessageTimer = window.setTimeout(() => {
      this.hideUnavailableMessage();
    }, 2500);
  }

  hideUnavailableMessage() {
    const message = this.querySelector('[data-variant-unavailable-message]');
    if (!message) return;
    message.classList.remove('is-visible');
    message.hidden = true;
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    const availableSet = new Set(listOfAvailableOptions || []);
    listOfOptions.forEach((input) => {
      const value = input.getAttribute('value');
      const isAvailable = availableSet.has(value);
      if (input.tagName === 'OPTION') {
        input.disabled = !isAvailable;
        input.dataset.unavailable = isAvailable ? 'false' : 'true';
        input.textContent = isAvailable
          ? value
          : window.variantStrings.unavailable_with_option.replace('[value]', value);
      } else {
        input.classList.toggle('disabled', !isAvailable);
        input.setAttribute('aria-disabled', isAvailable ? 'false' : 'true');
        input.dataset.unavailable = isAvailable ? 'false' : 'true';
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  updateInventoryStatus() {
    this.productInventoryNode = document.querySelector('[data-product-inventory]');

    if (!this.productInventoryNode || !window.inventories || !window.inventories[this.dataset.productId]) return;

    this.inventoryThreshold = parseInt(this.productInventoryNode.dataset.threshold);
    this.showQuantityInStock = this.productInventoryNode.dataset.showQuantityInStock;

    const variantInventoryObject = window.inventories[this.dataset.productId][this.currentVariant?.id];

    if (!this.currentVariant || !this.currentVariant.inventory_management) {
      this.toggleInventoryQuantity(false);
      this.toggleIncomingInventory(false);

      return;
    }

    if (this.currentVariant.inventory_management === 'shopify') {
      if (variantInventoryObject.quantity <= 0 && variantInventoryObject.incoming === 'true' && variantInventoryObject.quantity < this.inventoryThreshold) {
        this.toggleInventoryQuantity(false);
        this.toggleIncomingInventory(true, variantInventoryObject.next_incoming_date);
      } else {
        this.toggleInventoryQuantity(true, variantInventoryObject.quantity);
        this.toggleIncomingInventory(false);
      }
    }
  }

  toggleInventoryQuantity(show, quantity) {
    if (show === false) {
      this.productInventoryNode.classList.add('hide');
      return;
    }

    this.productInventoryNode.classList.remove('inventory-status--in-stock', 'inventory-status--low', 'inventory-status--sold-out', 'inventory-status--sold-out-continue-selling');

    if (this.currentVariant && this.currentVariant.available && parseInt(quantity) <= parseInt(this.inventoryThreshold) && parseInt(quantity) > 0) {
      this.productInventoryNode.classList.add('inventory-status--low');
      if (this.showQuantityInStock === 'true') {
        this.productInventoryNode.firstElementChild.textContent = window.variantStrings.inventory.few_left_with_quantity.replace('[quantity]', quantity);
      } else {
        this.productInventoryNode.firstElementChild.textContent = window.variantStrings.inventory.few_left;
      }
    } else if (this.currentVariant && this.currentVariant.available && parseInt(quantity) > parseInt(this.inventoryThreshold)) {
      this.productInventoryNode.classList.add('inventory-status--in-stock');
      if (this.showQuantityInStock === 'true') {
        this.productInventoryNode.firstElementChild.textContent = window.variantStrings.inventory.in_stock_with_quantity.replace('[quantity]', quantity);
      } else {
        this.productInventoryNode.firstElementChild.textContent = window.inventories[this.dataset.productId][this.currentVariant.id].estimated_delivery_time
      }
    } else if (this.currentVariant && this.currentVariant.available && parseInt(quantity) < 1) {
      this.productInventoryNode.classList.add('inventory-status--sold-out-continue-selling');
      this.productInventoryNode.firstElementChild.textContent = window.inventories[this.dataset.productId][this.currentVariant.id].estimated_delivery_time
    } else if (this.currentVariant && this.currentVariant.available) {
      this.productInventoryNode.classList.add('inventory-status--in-stock');
      this.productInventoryNode.firstElementChild.textContent = window.inventories[this.dataset.productId][this.currentVariant.id].estimated_delivery_time
    } else {
      this.productInventoryNode.classList.add('inventory-status--sold-out');
      this.productInventoryNode.firstElementChild.textContent = window.variantStrings.inventory.out_of_stock;
    }

    this.productInventoryNode.classList.remove('hide');
  }

  toggleIncomingInventory(show, date) {
    const incomingInventoryNode = document.querySelector('[data-incoming-inventory]');
    if (!incomingInventoryNode) return;

    if (show == false && incomingInventoryNode) {
      incomingInventoryNode.classList.add('hide');

      return;
    }

    let string = !date ?
      window.variantStrings.inventory.waiting_for_stock :
      window.variantStrings.inventory.will_be_in_stock_after.replace('[date]', date);

    incomingInventoryNode.classList.remove('hide');
    incomingInventoryNode.firstElementChild.textContent = string;
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const destinationBuyBarInfo = document.getElementById(
          `buy-bar-info-${this.dataset.section}`
        );
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const buyBarInfoSource = html.getElementById(`buy-bar-info-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        if (source && destination) destination.innerHTML = source.innerHTML;
        if (source && destinationBuyBarInfo) destinationBuyBarInfo.innerHTML = buyBarInfoSource.innerHTML;

        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('hidden', skuSource.classList.contains('hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    const multiplyButtons = productForm.querySelectorAll('.btn--add-multiplier');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
      if (multiplyButtons) {
        multiplyButtons.forEach(button => {
          button.disabled = true;
        });
      }
    } else {
      addButton.removeAttribute('disabled');
      if (this.dataset.isPreorder == 'true') {
        addButtonText.textContent = window.variantStrings.preOrder;
      } else {
        addButtonText.textContent = window.variantStrings.addToCart;
      }
      if (multiplyButtons) {
        multiplyButtons.forEach(button => {
          button.removeAttribute('disabled');
        });
      }
    }

    const productForm_BuyBar = document.getElementById(
      `product-form-${this.dataset.section}-product-buy-bar`
    );
    if (productForm_BuyBar) {
      const addButton_BuyBar = productForm_BuyBar.querySelector('[name="add"]');
      const addButtonText_BuyBar = productForm_BuyBar.querySelector(
        '[name="add"] > span'
      );

      if (disable) {
        addButton_BuyBar.setAttribute("disabled", "disabled");
        if (text) addButtonText_BuyBar.textContent = text;
      } else {
        addButton_BuyBar.removeAttribute("disabled");
        if (this.dataset.isPreorder == "true") {
          addButtonText_BuyBar.textContent = window.variantStrings.preOrder;
        } else {
          addButtonText_BuyBar.textContent = window.variantStrings.addToCart;
        }
      }
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('hidden');

    const button_BuyBar = document.getElementById(
      `product-form-${this.dataset.section}-product-buy-bar`
    );
    const addButton_BuyBar = button_BuyBar.querySelector('[name="add"]');
    const addButtonText_BuyBar = button_BuyBar.querySelector(
      '[name="add"] > span'
    );
    const price_BuyBar = document.getElementById(
      `price-${this.dataset.section}-product-buy-bar`
    );
    if (!addButton_BuyBar) return;
    addButtonText_BuyBar.textContent = window.variantStrings.unavailable;
    if (price_BuyBar) price_BuyBar.classList.add("hidden");
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
    this.addEventListener('click', this.onOptionClick);
    this.addEventListener('keydown', this.onOptionKeydown);
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    const availableSet = new Set(listOfAvailableOptions || []);
    listOfOptions.forEach((input) => {
      const value = input.getAttribute('value');
      const isAvailable = availableSet.has(value);
      input.classList.toggle('disabled', !isAvailable);
      input.setAttribute('aria-disabled', isAvailable ? 'false' : 'true');
      input.dataset.unavailable = isAvailable ? 'false' : 'true';
    });
  }

  onOptionClick(event) {
    const target = event.target;
    let input = null;
    if (target.matches && target.matches('input[type="radio"]')) {
      input = target;
    } else {
      const label = target.closest ? target.closest('label') : null;
      if (label) {
        input = label.control || document.getElementById(label.getAttribute('for'));
      }
    }
    if (!input || !input.classList.contains('disabled')) return;
    event.preventDefault();
    event.stopPropagation();
    this.showUnavailableMessage();
  }

  onOptionKeydown(event) {
    if (event.key !== ' ' && event.key !== 'Enter') return;
    const input = event.target?.closest ? event.target.closest('input[type="radio"]') : null;
    if (!input || !input.classList.contains('disabled')) return;
    event.preventDefault();
    event.stopPropagation();
    this.showUnavailableMessage();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });

    this.updateLegends();
  }

  updateLegends() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    fieldsets.forEach((fieldset) => {
      const legend = fieldset.querySelector('legend [data-variant-legend]');
      const selectedOption = Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked);
      legend.textContent = selectedOption.getAttribute('value');
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductBuyBar extends HTMLElement {
  constructor() {
    "use strict";
    super();

    let classes = { show: "show" };
    let mainProductForm = document.querySelector(".product-form");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // In view -> Hide bar
            this.classList.remove(classes.show);
          } else if (window.scrollY > 200) {
            // Out of view AND scrolled a little from top -> Show bar
            this.classList.add(classes.show);
          }
        });
      },
      { threshold: 0.25 }
    );

    observer.observe(mainProductForm);

    // This script is loaded in product-template.liquid --> Footer observer after DOM ready
    document.addEventListener("DOMContentLoaded", function () {
      let siteFooter = document.querySelector("footer.footer");
      if (!siteFooter) return;
      observer.observe(siteFooter);
    });
  }
}
customElements.define("product-buy-bar", ProductBuyBar);

class UpsellCard extends HTMLElement {
  constructor() {
    super();
    this.select = this.querySelector('select');
    this.image = this.querySelector('.card-media img');

    if (this.select) {
      this.select.addEventListener('change', (event) => {
        const selectedOption = event.target.options[event.target.selectedIndex];
        const newImgSrc = selectedOption.getAttribute('data-variant-img-src');
        if (newImgSrc) { this.updateImage(newImgSrc) }
      });
    }
  }

  updateImage(newImgSrc) {
    if (this.image) {
      this.image.src = newImgSrc;
    }
  }
}

customElements.define('upsell-card', UpsellCard);

(function initQuantityMultiplesGlobal() {
  if (window.__QuantityMultiplesInit) return;
  window.__QuantityMultiplesInit = true;

  function toInt(v, fallback = 0) {
    const n = parseInt(String(v ?? '').trim(), 10);
    return Number.isFinite(n) ? n : fallback;
  }

  function getStep(input) {
    const stepAttr = input?.getAttribute?.('step');
    const dataAttr = input?.dataset?.minMultiple;
    const step = toInt(stepAttr || dataAttr, 1);
    return step > 0 ? step : 1;
  }

  function isCartContext(input) {
    if (!input) return false;
    const name = String(input.getAttribute('name') || '');
    if (name.includes('updates')) return true;
    if (input.dataset && input.dataset.index) return true;
    if (input.closest('#cart')) return true;
    if (input.closest('cart-items')) return true;
    if (input.closest('[data-drawer]')) return true;
    return false;
  }

  // Palauttaa min-arvon: cartissa min voi olla 0 (poisto), muuten min >= step
  function getMin(input, step) {
    const minAttrRaw = input?.getAttribute?.('min');
    const minAttr = minAttrRaw === null ? null : toInt(minAttrRaw, 0);

    const cart = isCartContext(input);

    // Cartissa kun min="0", 0 sallitaan aidosti
    if (cart && minAttr === 0) return 0;

    // Muuten min vähintään step
    const min = (minAttr === null) ? step : minAttr;
    return min > 0 ? Math.max(min, step) : step;
  }

  // Pyöristetään ylöspäin kerrannaiseksi. Cartissa 0 säilytetään 0:na.
  function snap(value, step, min, allowZero) {
    const raw = toInt(value, 0);

    if (allowZero && raw <= 0) return 0;

    const minPos = (min === 0) ? step : Math.max(min, step);
    const v = Math.max(raw, minPos);
    const snapped = Math.ceil(v / step) * step;
    return Math.max(snapped, minPos);
  }

  function sanitizeInput(input) {
    if (!(input instanceof HTMLInputElement)) return;
    if (input.type !== 'number') return;
    if (!input.closest('quantity-input')) return;

    const step = getStep(input);
    if (step <= 1) return;

    const min = getMin(input, step);
    const allowZero = (min === 0) && isCartContext(input);

    const next = snap(input.value, step, min, allowZero);
    const nextStr = String(next);
    if (input.value !== nextStr) input.value = nextStr;
  }

  function handleQuantityInputChangeOrBlur(e) {
    sanitizeInput(e.target);
  }

  function handleFormSubmit(e) {
    const form = e.target;
    if (!(form instanceof HTMLFormElement)) return;

    // Siivoa kaikki quantity-input kentät lomakkeessa
    form.querySelectorAll('quantity-input input[type="number"]').forEach((input) => {
      sanitizeInput(input);
    });
  }

  // HUOM: ei kaapata clickkejä ollenkaan -> teidän QuantityInput custom element hoitaa stepUp/stepDown.
  document.addEventListener('change', handleQuantityInputChangeOrBlur, true);
  document.addEventListener('blur', handleQuantityInputChangeOrBlur, true);
  document.addEventListener('submit', handleFormSubmit, true);
})();
